<script type="text/javascript">

export default {
  props: {
    transaction: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      items: {},
      filters: {
        q: null,
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.getItems()
  },
  methods: {
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.transaction.outbound', {
        transaction_uuid: this.transaction
      }) + '?q=')
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small">
    <a-skeleton :loading="loading" active>
      <a-tabs defaultActiveKey="outbound-0" tabPosition="left">
        <tab-pane :tab="moment(item.created_at).format('YYYY-MM-DD HH:mm:ss')" v-for="(item,index) in items.data"
                  :key="`outbound-${index}`">
          <json-source :source="item"/>
        </tab-pane>
      </a-tabs>
    </a-skeleton>
  </a-card>
</template>
